import store from './../game/store/index.js';
import * as turf from "@turf/turf";
import * as Graph from "./../libs/Graph";

const geo = {
	install(Vue, options) {

		Vue.prototype.$geo = {
			toTurf(coord) {
				if (coord[0] && coord[0].constructor !== Array) {
					return ol.proj.transform(coord, 'EPSG:3857', 'EPSG:4326')
				}
				let coordinates = [];
				for (let i in coord) {
					if (coord[i][0] && coord[i][0].constructor === Array) {
						coordinates.push([]);
						for (let j in coord[i]) {
							coordinates[i].push(ol.proj.transform(coord[i][j], 'EPSG:3857', 'EPSG:4326'))
						}
					}
					else coordinates.push(ol.proj.transform(coord[i], 'EPSG:3857', 'EPSG:4326'))
				}

				return coordinates;
			},
			toOL(coord) {
				if (coord[0] && coord[0].constructor !== Array) {
					return ol.proj.transform(coord, 'EPSG:4326', 'EPSG:3857')
				}
				let coordinates = [];
				for (let i in coord) {
					if (coord[i][0] && coord[i][0].constructor === Array) {
						coordinates.push([]);
						for (let j in coord[i]) {
							coordinates[i].push(ol.proj.transform(coord[i][j], 'EPSG:4326', 'EPSG:3857'));
						}
					}
					coordinates.push(ol.proj.transform(coord[i], 'EPSG:4326', 'EPSG:3857'));
				}

				return coordinates;
			},
			pathFinder(start, end, graph) {

				var points = { start: start, end: end };
				var segments = { start: {}, end: {} };
				var map = {};

				for (let key in points) {
					let coord = points[key];
					let point = turf.point(this.toTurf(coord));
					let index = this.hashString(coord);

					segments[key] = graph.getClosestFeatureToCoordinate(coord);

					let segment_points = { a: segments[key].getGeometry().getFirstCoordinate(), b: segments[key].getGeometry().getLastCoordinate() };

					map[index] = {};
					map[this.hashString(segment_points.a)] = {};
					map[this.hashString(segment_points.b)] = {};

					for (let i in segment_points) {
						let from = turf.point(this.toTurf(segment_points[i]));
						let distance = turf.distance(from, point);
						map[index][this.hashString(segment_points[i])] = distance;
						map[this.hashString(segment_points[i])][index] = distance;
					}
				}

				graph.forEachFeature((feature) => {
					if (feature.id != segments.start.id && feature.id != segments.end.id) {
						let coord = feature.getGeometry().getCoordinates();
						let segment_points = { a: coord[0], b: coord[coord.length - 1] };

						let line = turf.lineString(this.toTurf(coord));
						let length = turf.length(line);
						let indexA = this.hashString(segment_points.a)
						let indexB = this.hashString(segment_points.b);

						if (!map[indexA]) map[indexA] = {};
						if (!map[indexB]) map[indexB] = {};

						map[indexA][indexB] = length;
						map[indexB][indexA] = length;

						let segment_connections = { a: [], b: [] };
						for (let key in segment_connections) {
							let point = segment_connections[key];
							let pointFeature = new ol.Feature({ geometry: new ol.geom.Point(point) });
							let index = this.hashString(point);
							graph.forEachFeatureIntersectingExtent(pointFeature.getGeometry().getExtent(), (f) => {
								let coord = f.getGeometry().getCoordinates();
								let other_end = (coord[0] == point) ? coord[coord.length - 1] : coord[0];
								let other_index = this.hashString(other_end);
								let line = turf.lineString(this.toTurf(coord));
								let length = turf.length(line);

								if (!map[index]) map[index] = {};
								map[index][other_index] = distance;

								if (!map[other_index]) map[other_index] = {};
								map[other_index][index] = distance;
							});
						}
					}
				});


				let map_graph = new Graph(map);
				let path = map_graph.findShortestPath(this.hashString(start), this.hashString(end));
				if (!path) return null;
				let route = [];
				for (let i in path) {
					let coords = atob(path[i]).split(',');
					coords[0] = parseFloat(coords[0]);
					coords[1] = parseFloat(coords[1]);
					route.push(coords);
				}

				return route;
			},
			hashString(str) {
				str = str.join(',');
				return btoa(str);
			},
			getShortestLine(geom1, geom2) {
				if (geom1.getType() === 'Point' && geom2.getType() === 'Point') {
					return new ol.geom.LineString([geom1.getCoordinates(), geom2.getCoordinates()]);
				}

				let result = [];
				let distanceSq = Infinity;

				let geom1Coordinates = [];
				if (geom1.getType() === 'Polygon') {
					geom1Coordinates = geom1.getLinearRing(0).getCoordinates();
				} else if (geom1.getType() === 'Point') {
					geom1Coordinates = [geom1.getCoordinates()];
				} else {
					geom1Coordinates = geom1.getCoordinates();
				}

				let geom2Coordinates = [];
				if (geom2.getType() === 'Polygon') {
					geom2Coordinates = geom2.getLinearRing(0).getCoordinates();
				} else if (geom2.getType() === 'Point') {
					geom2Coordinates = [geom2.getCoordinates()];
				} else {
					geom2Coordinates = geom2.getCoordinates();
				}

				geom1Coordinates.forEach(coordinates => {
					const closest = geom2.getClosestPoint(coordinates);
					const distanceNew = Math.pow(closest[0] - coordinates[0], 2) + Math.pow(closest[1] - coordinates[1], 2);
					if (distanceNew < distanceSq) {
						distanceSq = distanceNew;
						result = [coordinates, closest];
					}
				});

				geom2Coordinates.forEach(coordinates => {
					const closest = geom1.getClosestPoint(coordinates);
					const distanceNew = Math.pow(closest[0] - coordinates[0], 2) + Math.pow(closest[1] - coordinates[1], 2);
					if (distanceNew < distanceSq) {
						distanceSq = distanceNew;
						result = [closest, coordinates];
					}
				});

				return new ol.geom.LineString(result);
			},
			drawPath(route, color) {

				let overlayLayer = store.state.map.overlayLayer;
				if (!color) color = 'grey';

				route.forEach((segment) => {
					var road = new ol.Feature({ geometry: new ol.geom.LineString(segment.path) });
					road.setStyle(new ol.style.Style({ 'stroke': new ol.style.Stroke({color: color, width:4}) }));

					overlayLayer.addFeature(road);

					segment.path.forEach((coord) => {
						overlayLayer.addFeature(new ol.Feature({ geometry: new ol.geom.Point(coord) }));
					});
				})
			},
		}

	}
};

export default geo;
